// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--HKHMG","house":"_0bc5e8de02--house--j2iLW","text":"_0bc5e8de02--text--OBbgl","arrow":"_0bc5e8de02--arrow--XwVFC"};